// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2taa6","col":"styles_col__18ZtB"};